import declare from "dojo/_base/declare";
import crews from "csi/access/crews";
import Action from "csi/def/Action";
import { featureTogglesStore } from "csi/state/rootStore";


const ArchiveSeasonAction =  declare(Action, {

	isHidden: function(ctx) {
		// summary: return true if user has no access to action
		return !featureTogglesStore.ENABLE_ARCHIVING || !crews.isAdmin() || !crews.isArchiveAdmin(ctx.getContextNode()) || Action.prototype.isHidden.call(this, ctx);
	},
});

export = ArchiveSeasonAction;